import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { SettingsProvider } from './context/SettingsContext';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import ExcursionsPage from './pages/ExcursionsPage';
import AdminLogin from './pages/AdminLogin';
import AdminLayout from './pages/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminReservations from './pages/AdminReservations';
import AdminExcursions from './pages/AdminExcursions';
import AdminHotels from './pages/AdminHotels';
import AdminAirports from './pages/AdminAirports';
import AdminVehicles from './pages/AdminVehicles';
import AdminSettings from './pages/AdminSettings';
import ProtectedRoute from './pages/ProtectedRoute';
import './App.css';

function App() {
  useEffect(() => {
    document.title = 'TTS - Transporte Turístico Santos';
    // Remove Emergent badge if present
    const removeBadge = () => {
      const sel = 'a[href*="app.emergent.sh"], a[href*="emergent-badge"], #emergent-badge, .emergent-badge';
      document.querySelectorAll(sel).forEach(el => {
        try { el.remove(); } catch (e) { el.style.display = 'none'; }
      });
    };
    removeBadge();
    const interval = setInterval(removeBadge, 1500);
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, []);

  return (
    <LanguageProvider>
      <SettingsProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/excursiones" element={<ExcursionsPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="reservations" element={<AdminReservations />} />
                <Route path="excursions" element={<AdminExcursions />} />
                <Route path="hotels" element={<AdminHotels />} />
                <Route path="airports" element={<AdminAirports />} />
                <Route path="vehicles" element={<AdminVehicles />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </div>
      </SettingsProvider>
    </LanguageProvider>
  );
}

export default App;
